var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_time_534804_000000") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLOW---MOBILE/DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Denuncia-Sinistro---MeteoAvverso---DataCheck---OK",
    transform: "translate(-762.000000, -343.000000)",
    fill: "#059881",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(520.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_time_534804_000000",
    transform: "translate(242.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.66624,10 C10.56624,10 10.464368,9.9775008 10.368736,9.93 L7.701856,8.59688 C7.4756,8.4837552 7.333104,8.253136 7.333104,8 L7.333104,3.33312 C7.333104,2.964992 7.631856,2.66624 7.999984,2.66624 C8.368112,2.66624 8.666864,2.964992 8.666864,3.33312 L8.666864,7.58752 L10.964944,8.736896 C11.29432,8.901264 11.42744,9.302528 11.263072,9.631264 C11.1461968,9.864384 10.9112,9.999392 10.666192,9.999392 L10.66624,10 Z M8,16 C3.5888,16 0,12.4112 0,8 C0,3.5888 3.5888,0 8,0 C12.4112,0 16,3.5888 16,8 C16,12.4112 12.4112,16 8,16 Z M8,1.33312 C4.32368,1.33312 1.33312,4.32368 1.33312,8 C1.33312,11.67632 4.32368,14.66688 8,14.66688 C11.67632,14.66688 14.66688,11.67632 14.66688,8 C14.66688,4.32368 11.67632,1.33312 8,1.33312 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeicon);
export default __webpack_public_path__ + "static/media/time.icon.80b3d951d1d41c3d8b15096002ae1c5c.svg";
export { ForwardRef as ReactComponent };